import { useFollow } from '@/app/components/shared/Community';
import { FollowButton } from '@/app/components/shared/FollowButton';
import { Medal } from '@/app/components/shared/Medal';
import { UserAvatar } from '@/app/components/shared/UserAvatar';
import { useGoToProfile } from '@/app/hooks';
import { useStore } from '@/app/providers/store';
import type { UserInfo as UserInfoType } from '@/app/types';
import { cn } from '@/app/utils';
import type { CreatorV1Type, InspirationCreator } from '../types';

interface Props {
  user: UserInfoType | InspirationCreator | CreatorV1Type;
  className?: string;
  ipLocation?: string;
}

export const UserInfo = ({ user, className, ipLocation }: Props) => {
  const { userInfo } = useStore((state) => ({
    userInfo: state.userInfo,
  }));

  const avatar = user.avatar;
  const nickname = ('nick_name' in user ? user.nick_name : 'nickname' in user ? user.nickname : '') || '';
  const userId = user.id;
  const medals =
    'user_medal' in user
      ? [
          {
            user_medal_type: user.user_medal,
            is_active: true,
          },
        ]
      : [];

  const { goToProfile } = useGoToProfile();

  const { state: followState, handleFollow } = useFollow(userId || '', {
    initialIsFollowing: ('is_following' in user ? user.is_following : false) || false,
  });

  return (
    <div
      className={cn('flex cursor-pointer items-center gap-2 md:mt-5', className)}
      onClick={() => goToProfile(userId)}
    >
      <UserAvatar
        userInfo={{
          avatar: avatar || '',
          created_at: '',
          gender: 'unspecified',
          id: userId || '',
          nickname: nickname || '',
          role: 'user',
        }}
      />

      <div className="flex min-w-0 flex-col">
        <div className="flex items-center gap-2">
          <span className="max-w-[180px] truncate font-semibold text-sm md:max-w-[290px]">{nickname}</span>
          <Medal medals={medals} size={18} onClick={() => goToProfile(userId)} />
          {/* 自己投的灵感、短片、教程 / 个人作品，不展示关注按钮 */}

          <FollowButton
            className={cn(
              'h-[29px] shrink-0 text-xs',
              'is_following' in user && userId !== userInfo?.id ? 'visible' : 'invisible',
            )}
            isFollowing={followState.isFollowing}
            onClick={handleFollow}
            variant="ghost"
          />
        </div>
        {ipLocation && <span className="-mt-1.5 text-system-white/50 text-xs">IP {ipLocation}</span>}
      </div>
    </div>
  );
};
